'use client';

import React from 'react';
import { useGlobalClientContext } from '../common/GlobalClientContext';

export default function Introduce() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();

  return (
    <div className="z-20 w-full h-fit bg-base-white flex flex-col items-center justify-center py-10xl">
      <div className="w-full flex min-h-[calc(100%-84px)] relative flex-1 flex-col items-center h-full overflow-hidden">
          <div className="w-full shrink-0 flex flex-col gap-[36px]">
            <div className="flex flex-col items-center">
              <div className="font-display font-semibold text-xl leading-lg text-cic-blue-500 flex-grow-1 h-fit break-words whitespace-normal">
                {t('public.site.top.menu.pricing', {})}
              </div>
              <div className="font-display font-semibold text-6xl leading-19xl text-gray-900 text-center h-fit break-words whitespace-normal pt-2xl pb-5xl">
                {t('public.site.pricing.sub.title1', {})} <br />
                {t('public.site.pricing.sub.title2', {})}
              </div>
              <div className="font-body font-regular text-xl leading-3xl text-secondary text-center">
                {t('public.site.pricing.sub.description', {})} <br />
                {t('public.site.pricing.sub.description1', {})}
              </div>
            </div>
          </div>
      </div>
    </div>
  );
}
